import { createContext, useState } from "react";
import { useEffect } from "react";
import SGAPIS from "./singaporeData.json";
import MYAPIS from "./MalaysiaData.json";
import AUAPIS from "./AustraliaData.json";
import UAEAPIS from "./UaeData.json";
import OMANAPIS from "./OmanData.json";
import ZAAPIS from "./SouthAfricaData.json";
// Create the context
export const RegionContext = createContext();

// Create a provider component
export const RegionProvider = ({ children }) => {
  const [data, setData] = useState({
    region: "sg",
    api_collection: SGAPIS,
    current_api: {},
    drawer_open: false,
  });

  useEffect(() => {
    if (
      window.location.host === "devsgp.paymateb2b.com" ||
      window.location.host === "api.paymate.sg"
    ) {
      setData((prevState) => ({
        ...prevState,
        api_collection: SGAPIS,
        region: "sg",
      }));
    } else if (
      window.location.host === "devmys.paymateb2b.com" ||
      window.location.host === "api.paymate.my"
    ) {
      setData((prevState) => ({
        ...prevState,
        api_collection: MYAPIS,
        region: "my",
      }));
    } else if (
      window.location.host === "devaus.paymateb2b.com" ||
      window.location.host === "api.dunomo.au"
    ) {
      setData((prevState) => ({
        ...prevState,
        api_collection: AUAPIS,
        region: "au",
      }));
    } else if (
      window.location.host === "devuae.paymateb2b.com" ||
      window.location.host === "api.paymate.ae"
    ) {
      setData((prevState) => ({
        ...prevState,
        api_collection: UAEAPIS,
        region: "ae",
      }));
    } else if (
      window.location.host === "devomn.paymateb2b.com" ||
      window.location.host === "api.paymate.om"
    ) {
      setData((prevState) => ({
        ...prevState,
        api_collection: OMANAPIS,
        region: "om",
      }));
    } else if (
      window.location.host === "devzaf.paymateb2b.com" ||
      window.location.host === "api.dunomo.co.za"
    ) {
      setData((prevState) => ({
        ...prevState,
        api_collection: ZAAPIS,
        region: "za",
      }));
    } else {
      setData((prevState) => ({
        ...prevState,
        api_collection: AUAPIS,
        region: "au",
      }));
    }
  }, [window.location]);

  return (
    <RegionContext.Provider value={{ data, setData }}>
      {children}
    </RegionContext.Provider>
  );
};
